import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'
import authService from '../services/auth.service'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    meta: { requiresAuth: true },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'projects',
        path: 'projects',
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'user-profile',
        path: 'profile',
        component: () => import('../pages/user/profile/index.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'payment-methods',
            path: 'payment-methods',
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
      {
        name: 'products',
        path: 'products',
        component: () => import('../pages/products/ProductListPage.vue'),
      },
      {
        name: 'products-direct',
        path: 'products-direct',
        component: () => import('../pages/products/ProductListPage.vue'),
      },
      {
        name: 'user-list',
        path: 'user-list',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'api-test',
        path: 'api-test',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'user-roles',
        path: 'user-roles',
        component: () => import('../pages/users/UserRolesPage.vue'),
      },
      {
        name: 'product-list',
        path: 'product-list',
        component: () => import('../pages/products/ProductListPage.vue'),
      },
      {
        name: 'product-categories',
        path: 'product-categories',
        component: () => import('../pages/products/CategoriesPage.vue'),
      },
      {
        name: 'product-brands',
        path: 'product-brands',
        component: () => import('../pages/products/ProductListPage.vue'),
      },
      {
        name: 'order-list',
        path: 'order-list',
        component: () => import('../pages/orders/OrderListPage.vue'),
      },
      {
        name: 'order-returns',
        path: 'order-returns',
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'company-list',
        path: 'company-list',
        component: () => import('../pages/companies/CompaniesPage.vue'),
      },
      {
        name: 'company-operations',
        path: 'company-operations/:id',
        component: () => import('../pages/companies/CompanyOperationsPage.vue'),
      },
      {
        name: 'job-list',
        path: 'job-list',
        component: () => import('../pages/jobs/JobsPage.vue'),
      },
      {
        name: 'job-seeker-list',
        path: 'job-seeker-list',
        component: () => import('../pages/jobs/JobSeekersPage.vue'),
      },
      {
        name: 'article-list',
        path: 'article-list',
        component: () => import('../pages/articles/ArticlesPage.vue'),
      },
      {
        name: 'driving-order-list',
        path: 'driving-order-list',
        component: () => import('../pages/driving/DrivingOrdersPage.vue'),
      },
      {
        name: 'driving-order-list',
        path: 'driving-order-list',
        component: () => import('../pages/driving/DrivingOrderList.vue'),
      },
      {
        name: 'driver-list',
        path: 'driver-list',
        component: () => import('../pages/driving/DriversPage.vue'),
      },
      {
        name: 'driver-withdrawals',
        path: 'driver-withdrawals',
        component: () => import('../pages/driving/WithdrawalsPage.vue'),
      },
      {
        name: 'car-wash-cards',
        path: 'car-wash-cards',
        component: () => import('../pages/car-service/CarWashCardsPage.vue'),
      },
      {
        name: 'user-car-wash-cards',
        path: 'user-car-wash-cards',
        component: () => import('../pages/car-service/UserCarWashCardsPage.vue'),
      },
      {
        name: 'merchant-transactions',
        path: 'merchant-transactions',
        component: () => import('../pages/merchants/MerchantTransactionsPage.vue'),
      },
      {
        name: 'merchant-categories',
        path: 'merchant-categories',
        component: () => import('../pages/merchants/MerchantCategoriesPage.vue'),
      },
      {
        name: 'article-create',
        path: 'article-create',
        component: () => import('../pages/articles/ArticleEdit.vue'),
      },
      {
        name: 'article-edit',
        path: 'article-edit/:id',
        component: () => import('../pages/articles/ArticleEdit.vue'),
      },
      {
        name: 'house-list',
        path: 'house-list',
        component: () => import('../pages/houses/HousesPage.vue'),
      },
      {
        name: 'communities',
        path: 'communities',
        component: () => import('../pages/communities/CommunitiesPage.vue'),
      },
      {
        name: 'house-categories',
        path: 'house-categories',
        component: () => import('../pages/houses/HouseCategoriesPage.vue'),
      },
      {
        name: 'second-hands',
        path: 'second-hands',
        component: () => import('../pages/second-hands/SecondHandsPage.vue'),
      },
      {
        name: 'second-hand-cars',
        path: 'second-hand-cars',
        component: () => import('../pages/second-hands/SecondHandCarsPage.vue'),
      },
      {
        name: 'second-hand-goods-categories',
        path: 'second-hand-goods-categories',
        component: () => import('../pages/second-hands/SecondHandCategoriesPage.vue'),
      },
      {
        name: 'second-hand-cars-categories',
        path: 'second-hand-cars-categories',
        component: () => import('../pages/second-hands/SecondHandCarCategoriesPage.vue'),
      },
      {
        name: 'life-services',
        path: 'life-services',
        component: () => import('../pages/life-services/LifeServicesPage.vue'),
      },
      {
        name: 'life-service-categories',
        path: 'life-service-categories',
        component: () => import('../pages/life-services/LifeServiceCategoriesPage.vue'),
      },
      {
        name: 'lost-found',
        path: 'lost-found',
        component: () => import('../pages/lost-found/LostFoundPage.vue'),
      },
      {
        name: 'lost-found-categories',
        path: 'lost-found-categories',
        component: () => import('../pages/lost-found/LostFoundCategoriesPage.vue'),
      },
      {
        name: 'free-zone',
        path: 'free-zone',
        component: () => import('../pages/free-zone/FreeZonePage.vue'),
      },
      {
        name: 'free-zone-categories',
        path: 'free-zone-categories',
        component: () => import('../pages/free-zone/FreeZoneCategoriesPage.vue'),
      },
      {
        name: 'site-settings',
        path: 'site-settings',
        component: () => import('../pages/settings/SiteSettings.vue'),
      },
      {
        name: 'shipping-settings',
        path: 'shipping-settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'driving-settings',
        path: 'driving-settings',
        component: () => import('../pages/driving/DrivingSettingsPage.vue'),
      },
      {
        name: 'content-migration',
        path: 'content-migration',
        component: () => import('../pages/content-migration/ContentMigrationPage.vue'),
      },
      {
        name: 'dining-scan-order',
        path: 'dining-scan-order',
        component: () => import('../pages/dining/DiningCategoriesPage.vue'),
      },
      {
        name: 'dining-dishes',
        path: 'dining-dishes',
        component: () => import('../pages/dining/DiningDishesPage.vue'),
      },
      {
        name: 'dining-group-buying',
        path: 'dining-group-buying',
        component: () => import('../pages/dining/DiningGroupBuyingPage.vue'),
      },
      {
        name: 'dining-takeout',
        path: 'dining-takeout',
        component: () => import('../pages/dining/DiningTakeoutPage.vue'),
      },
      {
        name: 'dining-tables',
        path: 'dining-tables',
        component: () => import('../pages/dining/DiningTablesPage.vue'),
      },
      {
        name: 'dining-queue',
        path: 'dining-queue',
        component: () => import('../pages/dining/DiningQueuePage.vue'),
      },
      {
        name: 'dining-store-settings',
        path: 'dining-store-settings',
        component: () => import('../pages/dining/DiningStoreSettingsPage.vue'),
      },
      {
        name: 'spec-groups',
        path: 'spec-groups',
        component: () => import('../pages/dining/SpecGroupsPage.vue'),
      },
      {
        name: 'spec-options',
        path: 'spec-options',
        component: () => import('../pages/dining/SpecOptionsPage.vue'),
      },
      {
        name: 'coupons',
        path: 'coupons',
        component: () => import('../pages/dining/CouponsPage.vue'),
      },
      // ===== 会员系统 =====
      {
        name: 'member-levels',
        path: 'member-levels',
        component: () => import('../pages/member/MemberLevelsPage.vue'),
      },
      {
        name: 'user-memberships',
        path: 'user-memberships',
        component: () => import('../pages/member/UserMembershipsPage.vue'),
      },
      {
        name: 'points-log',
        path: 'points-log',
        component: () => import('../pages/member/PointsLogPage.vue'),
      },
      {
        name: 'balance-log',
        path: 'balance-log',
        component: () => import('../pages/member/BalanceLogPage.vue'),
      },
      {
        name: 'recharge-orders',
        path: 'recharge-orders',
        component: () => import('../pages/member/RechargeOrdersPage.vue'),
      },
      {
        name: 'member-settings',
        path: 'member-settings',
        component: () => import('../pages/member/MemberSettingsPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'auth-login',
        path: 'login',
        component: () => import('../pages/auth/login/index.vue'),
        meta: { guest: true },
      },
      {
        name: 'auth-signup',
        path: 'signup',
        component: () => import('../pages/auth/signup/index.vue'),
        meta: { guest: true },
      },
      {
        name: 'auth-forgot-password',
        path: 'forgot-password',
        component: () => import('../pages/auth/forgot-password/index.vue'),
        meta: { guest: true },
      },
      {
        name: 'auth-reset-password',
        path: 'reset-password',
        component: () => import('../pages/auth/reset-password/index.vue'),
        meta: { guest: true },
      },
      {
        path: '',
        redirect: { name: 'auth-login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const isGuestRoute = to.matched.some((record) => record.meta.guest)
  const isAuthenticated = authService.isAuthenticated()

  // 需要认证但未登录，清除会话并跳转登录页（直接退出登录）
  if (requiresAuth && !isAuthenticated) {
    // ensure token cleared and redirect to login
    authService.logout()
    return
  }
  // 已登录但访问游客页面（如登录、注册），重定向到首页
  else if (isGuestRoute && isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    // 检查代驾运营的页面访问权限
    const user = authService.getUser()
    if (user && user.role === 'operator') {
      // 代驾运营允许访问的页面
      const allowedPages = [
        'dashboard',
        'driving-order-list',
        'driver-list',
        'driver-withdrawals',
        'driving-settings',
        'user-list',
      ]

      if (!allowedPages.includes(to.name as string)) {
        // 尝试访问不允许的页面，重定向到仪表盘
        return next({ name: 'dashboard' })
      }
    }

    next()
  }
})

export default router
